import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "@mui/material";

import { useThemeContext } from "../../context/ThemeContext";

import { AppBodyLayoutWrapper } from "./styles";
const AppBodyLayout = () => {
  const { mode } = useThemeContext();

  return (
    <AppBodyLayoutWrapper mode={mode}>
      <Container sx={{ maxWidth: "1468px !important" }}>
        <Outlet />
      </Container>
    </AppBodyLayoutWrapper>
  );
};

export default AppBodyLayout;
